import {
  resolveServiceRequestOwnerId,
  type ServiceRequestResource,
} from 'domains-work-order-authorization';
import { safeConvertToUUID } from 'uuid-encoding';

interface IdRef {
  id?: string | null;
}

export interface ServiceRequestRecord {
  serviceRequestId: string;
  channelId?: IdRef | null;
  company?: IdRef | null;
  createdBy?: IdRef | null;
  submitOnBehalfOf?: IdRef | null;
  assignee?: IdRef | null;
  assigneeGroups?: (string | null)[] | null;
}

export const toResource = (
  record: ServiceRequestRecord
): ServiceRequestResource => ({
  resourceId: safeConvertToUUID(record.serviceRequestId),
  channelId: record.channelId?.id ?? '',
  companyId: record.company?.id ?? '',
  ownerId: resolveServiceRequestOwnerId({
    createdBy: record.createdBy?.id ?? '',
    submitOnBehalfOf: record.submitOnBehalfOf?.id,
  }),
  assigneeId: record.assignee?.id ?? undefined,
  assigneeGroupIds: (record.assigneeGroups ?? []).filter((id): id is string =>
    Boolean(id)
  ),
});
